export default __webpack_public_path__ + "assets/enterprise-two-three-small.a4868815e9673bcf3258423a118f7458.png";